export const COMPACT_MIN_WIDGET_WIDTH = 400;
export const COMPACT_MAX_WIDGET_WIDTH = 980;
